import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    COUNTRY_GUIDE_CONTENT,
    fetchCountryGuideAction,
} from 'wanderu-ducks-seo';
import { localize } from 'wanderu-i18n';
import Widget from 'wanderu-widget';

import { generateLocaleAwareGuideId } from '../../utils';
import PlaceGuideContainer from '../PlaceGuide/PlaceGuide';

class CountryGuideContainer extends React.Component {
    static async serverFetchData(opts) {
        const {
            dispatch,
            params,
        } = opts;

        const {
            mode,
            locale,
            country,
        } = params;

        const countryGuideId = generateLocaleAwareGuideId(params);

        await Promise.all([
            dispatch(
                fetchCountryGuideAction.fetchCountryGuide(countryGuideId, country, mode, locale),
            ),
            Widget.serverFetchData(opts),
        ]);

        await PlaceGuideContainer.serverFetchData({ ...opts, placeId: countryGuideId });
    }

    async componentDidMount() {
        const {
            match,
            isLoaded,
            countryGuideId,
            fetchCountryGuide,
        } = this.props;

        if (!isLoaded) {
            const {
                mode,
                locale,
                country,
            } = match.params;

            fetchCountryGuide(countryGuideId, country, mode, locale);
        }
    }

    async componentDidUpdate(prevProps) {
        const {
            match,
            countryGuideId,
        } = this.props;
        const {
            countryGuideId: previousCountryGuideId,
        } = prevProps;

        if (countryGuideId !== previousCountryGuideId) {
            const queryParams = match.params;

            this.props.fetchCountryGuide(
                countryGuideId,
                queryParams.country,
                queryParams.mode,
                queryParams.locale,
            );
        }
    }

    render() {
        return (
            <PlaceGuideContainer
                {...this.props}
                generalSectionContent={COUNTRY_GUIDE_CONTENT}
                placeGuideId={this.props.countryGuideId}
                hideCarrierStatsTable
                popularRoutesData
                showBreadcrumbs
                showCheapestTicket
                showGeneralSection
                showInfoSection
                showInterlinkSection
            />
        );
    }
}

CountryGuideContainer.propTypes = {
    countryGuideId: PropTypes.string.isRequired,
    fetchCountryGuide: PropTypes.func.isRequired,
    isLoaded: PropTypes.bool.isRequired,
    match: PropTypes.shape({
        params: PropTypes.shape({
            country: PropTypes.string.isRequired,
            locale: PropTypes.string.isRequired,
            mode: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

function mapStateToProps(state, ownProps) {
    const countryGuideId = generateLocaleAwareGuideId(ownProps.match.params);

    return {
        countryGuideId,
        error: fetchCountryGuideAction.selectError(state, countryGuideId),
        isFetching: fetchCountryGuideAction.selectWorking(state, countryGuideId),
        isLoaded: fetchCountryGuideAction.selectSuccess(state, countryGuideId),
        notFound: fetchCountryGuideAction.selectNotFound(state, countryGuideId),
    };
}

const mapDispatchToProps = {
    fetchCountryGuide: fetchCountryGuideAction.fetchCountryGuide,
};

export {
    CountryGuideContainer,
    mapStateToProps,
};

const localizedCountryGuide = localize(CountryGuideContainer, 'baseApp');
export default connect(mapStateToProps, mapDispatchToProps)(localizedCountryGuide);
